export default {
  setCurrentStage(state, stage) {
    state.currentStage = stage
  },
}
